import React from 'react'
import Profile from '../Profile'


const ProfilePage = () => {
    return (
        <Profile />
    )
}

export default ProfilePage


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/ProfilePage.js